var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _polygon, _polygon2, _polygon3, _path69, _style, _style2, _style3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4Tier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595.28,
    height: 841.89,
    id: "Layer_1",
    viewBox: "0 0 595.28 841.89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{fill-rule:evenodd;stroke:#000003;}.cls-1,.cls-3,.cls-4,.cls-9,.cls-10{fill:#e5340d;}.cls-1,.cls-5,.cls-6,.cls-7{stroke-width:2.13px;}.cls-1,.cls-5,.cls-7,.cls-8,.cls-9,.cls-10{stroke-miterlimit:22.93;}.cls-2,.cls-3,.cls-4,.cls-6{stroke-linejoin:round;}.cls-2,.cls-3,.cls-8,.cls-10{stroke-width:2.13px;}.cls-2,.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-4,.cls-9{stroke-width:2.21px;}.cls-5{fill:inherit;}\n            .cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{fill-rule:evenodd;stroke:#000003;}.cls-1,.cls-3,.cls-4,.cls-9,.cls-10{fill:#e5340d;}.cls-1,.cls-5,.cls-6,.cls-7{stroke-width:2.13px;}.cls-1,.cls-5,.cls-7,.cls-8,.cls-9,.cls-10{stroke-miterlimit:22.93;}.cls-2,.cls-3,.cls-4,.cls-6{stroke-linejoin:round;}.cls-2,.cls-3,.cls-8,.cls-10{stroke-width:2.13px;}.cls-2,.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-4,.cls-9{stroke-width:2.21px;}.cls-5{fill:inherit;}"))), /*#__PURE__*/React.createElement("rect", {
    id: "themed_ribbon",
    width: 100,
    height: 497,
    x: 253,
    y: 344,
    style: {
      strokeWidth: 0.940958,
      fill: "transparent"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9 rosette_color_1",
    d: "m74.98,322.64c27.25,124.11,149.95,202.63,274.06,175.38h0c124.11-27.25,202.63-149.95,175.38-274.06C497.17,99.84,374.47,21.32,250.36,48.57h0C126.25,75.82,47.73,198.52,74.98,322.64h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m223.53,499.99l69.24,12.35,26.59-148.99c-24.78,5.41-49.42.29-69.24-12.35l-26.58,148.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m142.58,453.59l59.24,37.91,81.56-127.45c-23.92-4.31-45.3-18-59.24-37.91h0l-81.56,127.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m85.54,379.73l40.23,57.7,124.14-86.55c-19.79-12.7-34.75-32.93-40.22-57.7l-124.15,86.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m384.78,496.8l-32.45-147.8c-9.62,6.7-20.69,11.66-32.86,14.33h0c-12.16,2.67-24.29,2.8-35.84.75h0l32.45,147.8,68.69-15.08Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m319.59,363.31l86.55,124.15,57.69-40.22-86.55-124.14c-12.7,19.79-32.92,34.75-57.69,40.22h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m352.54,348.86l127.45,81.56,37.91-59.24-127.46-81.56c-4.31,23.92-18,45.3-37.91,59.24h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m377.41,322.88l148.98,26.59,12.36-69.24-148.99-26.58c5.41,24.78.3,49.42-12.35,69.24Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m76.19,358.37l147.8-32.45c-6.7-9.62-11.66-20.69-14.33-32.86h0c-2.67-12.16-2.8-24.29-.75-35.84h0l-147.8,32.45,15.08,68.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m60.65,266.36l148.99,26.58c-5.41-24.78-.3-49.42,12.35-69.24l-148.99-26.58-12.35,69.24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m81.5,175.41l127.45,81.56c4.31-23.92,17.99-45.3,37.91-59.24h0l-127.45-81.56-37.91,59.23Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m135.57,99.36l86.55,124.15c12.7-19.79,32.93-34.75,57.69-40.22h0l-86.55-124.14-57.69,40.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m390.49,289.36l147.8-32.45-15.08-68.7-147.8,32.45c6.7,9.63,11.66,20.69,14.33,32.86h0c2.67,12.16,2.8,24.29.75,35.84Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m349.49,195.71c19.79,12.7,34.75,32.93,40.22,57.7l124.15-86.55-40.23-57.7-124.14,86.55Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m316.02,182.55c23.92,4.31,45.3,18,59.24,37.91l81.56-127.45-59.24-37.91-81.56,127.45Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m280.05,183.23c24.78-5.41,49.41-.29,69.24,12.35l26.58-148.99-69.24-12.35-26.58,148.98Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4 rosette_color_1",
    d: "m315.77,182.5l-32.45-147.8-68.69,15.08,32.45,147.8c9.63-6.7,20.69-11.66,32.86-14.33h0c12.17-2.67,24.3-2.8,35.84-.75Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8 rosette_color_2",
    d: "m95.23,273.3c0,112.93,91.54,204.47,204.47,204.47h0c112.93,0,204.47-91.54,204.47-204.47s-91.54-204.47-204.47-204.47h0c-112.93,0-204.47,91.54-204.47,204.47h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m190.38,455.56l57.75,23.92,51.47-124.26c-22.54-.03-42.95-9.16-57.75-23.92l-51.47,124.26Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m128.95,399.85l44.2,44.19,95.09-95.09c-19.94-8.3-35.89-24.26-44.2-44.2h0l-95.09,95.09Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m93.52,324.87l23.92,57.75,124.26-51.47c-14.76-14.8-23.89-35.21-23.92-57.75l-124.26,51.47Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m330.95,483.52v-134.48c-9.63,3.98-20.18,6.18-31.25,6.18h0c-11.07,0-21.62-2.2-31.25-6.18h0v134.48h62.5Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m299.81,355.22l51.47,124.26,57.75-23.92-51.47-124.26c-14.8,14.76-35.2,23.89-57.75,23.92h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m331.16,348.95l95.09,95.09,44.2-44.19-95.09-95.09c-8.3,19.94-24.25,35.89-44.2,44.2h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m357.7,331.15l124.26,51.47,23.92-57.75-124.26-51.47c-.03,22.54-9.16,42.95-23.92,57.75Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m89.47,304.55h134.48c-3.98-9.63-6.18-20.18-6.18-31.25h0c0-11.07,2.2-21.62,6.18-31.25H89.47v62.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m93.52,221.72l124.26,51.47c.03-22.54,9.16-42.95,23.92-57.75l-124.26-51.47-23.92,57.75Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m128.95,146.74l95.09,95.09c8.3-19.94,24.25-35.89,44.19-44.2h0l-95.09-95.09-44.2,44.19Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m190.38,91.03l51.47,124.26c14.8-14.76,35.2-23.89,57.75-23.92h0l-51.47-124.26-57.75,23.92Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m375.45,304.55h134.48v-62.5h-134.48c3.98,9.63,6.18,20.18,6.18,31.25h0c0,11.07-2.2,21.62-6.18,31.25Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m357.7,215.44c14.76,14.8,23.89,35.21,23.92,57.75l124.26-51.47-23.92-57.75-124.26,51.47Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m331.16,197.63c19.94,8.3,35.9,24.26,44.2,44.2l95.09-95.09-44.2-44.2-95.09,95.09Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m299.81,191.37c22.54.03,42.95,9.16,57.75,23.92l51.47-124.26-57.75-23.92-51.47,124.26Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 rosette_color_2",
    d: "m330.95,197.55V63.07h-62.5v134.48c9.63-3.98,20.18-6.18,31.25-6.18h0c11.07,0,21.62,2.2,31.25,6.18Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10 rosette_color_3",
    d: "m124.17,308.55c19.47,96.94,113.84,159.75,210.78,140.28h0c96.95-19.47,159.75-113.84,140.28-210.78-19.47-96.95-113.84-159.75-210.78-140.28h0c-96.94,19.47-159.75,113.84-140.28,210.79h0Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m237.27,448.61l53.7,10.58,22.76-115.55c-19.36,3.86-38.45-.46-53.7-10.58l-22.76,115.55Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m174.93,411.38l45.56,30.32,65.24-98.03c-18.55-3.69-35-14.63-45.56-30.32h0l-65.24,98.03Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m131.59,353.12l30.49,45.45,97.8-65.61c-15.22-10.16-26.58-26.1-30.49-45.45l-97.8,65.61Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m362.78,448.38l-23.19-115.45c-7.58,5.08-16.26,8.78-25.76,10.69h0c-9.5,1.91-18.94,1.84-27.89.08h0l23.19,115.45,53.66-10.78Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m313.92,343.6l65.61,97.8,45.45-30.49-65.61-97.8c-10.16,15.22-26.1,26.58-45.45,30.49h0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m339.75,332.82l98.03,65.24,30.32-45.56-98.03-65.24c-3.69,18.55-14.63,35-30.32,45.56h0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m359.47,312.96l115.54,22.76,10.58-53.7-115.55-22.76c3.86,19.36-.46,38.45-10.58,53.7Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m124.62,336.37l115.45-23.19c-5.08-7.58-8.78-16.26-10.69-25.76h0c-1.91-9.5-1.84-18.94-.08-27.89h0l-115.45,23.19,10.78,53.66Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m113.81,264.57l115.55,22.76c-3.86-19.36.46-38.45,10.58-53.7l-115.55-22.76-10.58,53.7Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m131.3,194.09l98.03,65.24c3.69-18.55,14.63-35,30.32-45.56h0l-98.03-65.24-30.32,45.56Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m174.42,135.67l65.61,97.8c10.16-15.22,26.1-26.58,45.45-30.49h0l-65.61-97.8-45.45,30.49Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m370.12,287.06l115.45-23.19-10.78-53.66-115.45,23.19c5.08,7.58,8.78,16.26,10.69,25.76h0c1.91,9.5,1.84,18.94.09,27.89Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m339.52,213.63c15.22,10.16,26.58,26.1,30.49,45.45l97.8-65.61-30.49-45.45-97.8,65.61Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m313.67,202.92c18.55,3.69,35,14.63,45.56,30.32l65.24-98.03-45.56-30.32-65.24,98.03Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m285.67,202.95c19.36-3.86,38.45.46,53.7,10.58l22.76-115.55-53.7-10.58-22.76,115.55Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3 rosette_color_3",
    d: "m313.47,202.88l-23.19-115.45-53.66,10.78,23.19,115.44c7.58-5.07,16.26-8.78,25.76-10.69h0c9.5-1.91,18.94-1.84,27.89-.08Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m149.95,273.3c0,82.7,67.04,149.75,149.75,149.75h0c82.71,0,149.75-67.04,149.75-149.75s-67.04-149.75-149.75-149.75h0c-82.71,0-149.75,67.04-149.75,149.75h0Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m219.63,406.78l42.29,17.52,37.7-91c-16.51-.02-31.46-6.71-42.29-17.52l-37.7,91Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m174.65,365.98l32.37,32.37,69.64-69.64c-14.61-6.08-26.29-17.76-32.37-32.37h0l-69.64,69.64Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m148.7,311.07l17.52,42.3,91-37.7c-10.81-10.84-17.5-25.78-17.52-42.29l-91.01,37.7Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m322.59,427.26v-98.49c-7.05,2.91-14.78,4.53-22.89,4.53h0c-8.11,0-15.83-1.61-22.89-4.52h0v98.49h45.78Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m299.78,333.29l37.7,91,42.29-17.52-37.7-91c-10.84,10.81-25.78,17.5-42.29,17.52h0Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m322.74,328.71l69.64,69.64,32.37-32.37-69.64-69.64c-6.08,14.61-17.76,26.29-32.37,32.37h0Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m342.18,315.67l91,37.7,17.52-42.3-91-37.7c-.02,16.51-6.71,31.46-17.52,42.29Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m145.74,296.18h98.49c-2.91-7.05-4.52-14.78-4.52-22.89h0c0-8.11,1.61-15.83,4.52-22.89h-98.49v45.78Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m148.7,235.52l91.01,37.7c.02-16.51,6.71-31.46,17.52-42.29l-91.01-37.7-17.52,42.29Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m174.65,180.61l69.64,69.64c6.08-14.6,17.76-26.29,32.37-32.37h0l-69.64-69.64-32.37,32.37Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m219.63,139.81l37.7,91.01c10.84-10.81,25.78-17.5,42.29-17.52h0l-37.7-91-42.29,17.52Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m355.18,296.18h98.49v-45.78h-98.49c2.91,7.05,4.52,14.78,4.52,22.89h0c0,8.11-1.61,15.83-4.52,22.89Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m342.18,230.92c10.81,10.84,17.5,25.78,17.52,42.3l91-37.7-17.52-42.29-91,37.69Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m322.74,217.88c14.6,6.08,26.29,17.76,32.37,32.37l69.64-69.64-32.37-32.37-69.64,69.64Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m299.78,213.3c16.51.02,31.45,6.71,42.29,17.52l37.7-91.01-42.29-17.52-37.7,91Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6 rosette_color_2",
    "data-colour_3_class": "cls-7 rosette_color_1",
    d: "m322.59,217.82v-98.49h-45.78v98.49c7.05-2.91,14.78-4.52,22.89-4.52h0c8.11,0,15.84,1.61,22.89,4.52Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1 rosette_color_3 not-white",
    points: "146.11,813.54 200.57,788.3 233.96,836.3 346.67,367.14 258.82,344.38 146.11,813.54"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7 rosette_color_2 not-white",
    points: "256.62,340.73 349.98,340.73 349.98,838.06 303.63,792.58 256.62,838.06 256.62,340.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10 rosette_color_1 not-white",
    points: "460.7,813.54 406.24,788.3 372.85,836.3 254.22,338.54 342.07,315.78 460.7,813.54"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7 bring_forward face_background",
    d: "m208.69,273.3c0,50.26,40.75,91.01,91.01,91.01h0c50.27,0,91.01-40.75,91.01-91.01h0c0-50.27-40.75-91.01-91.01-91.01s-91.01,40.74-91.01,91.01h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rosette_face",
    className: "bring_forward",
    x: 209,
    y: 182,
    width: 182,
    height: 182,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    id: "tail_text",
    className: "st4 st5 st6",
    "data-max_length": 6.6,
    "data-max_lines": 1,
    "data-min_line_length": 14,
    style: {
      fontSize: 52,
      fill: "transparent",
      transform: "translate(305.64px, 585.46px) rotate(90deg)",
      transformBox: "fill-box",
      transformOrigin: "center center",
      textAnchor: "middle"
    }
  }, "PRINTED\n        RIBBON TAIL TEXT"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    id: "tail_text_line_1",
    className: "st4 st5 st6",
    "data-max_length": 6.6,
    "data-max_lines": 1,
    "data-min_line_length": 14,
    style: {
      fontSize: 52,
      fill: "transparent",
      transform: "translate(320.64px, 585.46px) rotate(90deg)",
      transformBox: "fill-box",
      transformOrigin: "center center",
      textAnchor: "middle"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    id: "tail_text_line_2",
    className: "st4 st5 st6",
    "data-max_length": 6.6,
    "data-max_lines": 1,
    "data-min_line_length": 14,
    style: {
      fontSize: 31,
      fill: "transparent",
      transform: "translate(282.64px, 585.46px) rotate(90deg)",
      transformBox: "fill-box",
      transformOrigin: "center center",
      textAnchor: "middle"
    }
  }), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .rosette_color_1 {fill:#ff0000;}")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .rosette_color_2 {fill:white;}")), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .rosette_color_3 {fill:#ff0000;}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Tier);
export default __webpack_public_path__ + "static/media/4tier.48bd11c86891185c95531ee3a89e780a.svg";
export { ForwardRef as ReactComponent };